import { contentToAccordionItems } from '@kizi/comparator-components';

const faqContent = {
  labels: [
    'Waarom vragen we adresgegevens?',
    'Hoe werkt vergelijken en overstappen?',
    'Hoe actueel zijn de gegevens in de vergelijker?',
    'Waarom staat een aanbieder niet bij de resultaten?',
    'Welke aanbieders zitten in de vergelijker?',
    'Hoe lang duurt het voordat ik ben overgestapt?',
    'Kan ik een overstap annuleren?',
    'Kan ik mijn e-mailadres behouden bij het overstappen?',
    'Moet ik zelf mijn oude abonnement opzeggen?',
    'Waarmee onderscheidt de Consumentenbond zich van andere vergelijkers?',
    'Hoe werkt de cashback?',
  ],
  content: [
    `<p>
        We hebben je adresgegevens (postcode en huisnummer) nodig omdat niet alle providers overal hun diensten leveren. Soms zijn bepaalde pakketten niet mogelijk op jouw postcode.
      </p>
      <p>
        Je adresgegevens gebruiken we alleen voor het regelen van de overstap. Lees meer over je recht op privacy en de privacyverklaring van de Consumentenbond.
     </p>`,
    `<i>Doe de Postcodecheck</i>
     <p>
        Vul je postcode en huisnummer in. Geef ook aan welke diensten (pakket) je wilt vergelijken. Internet, bellen en/of digitale televisie, al dan niet in combinatie met elkaar.
        Je kunt zowel kabel, dsl als glasvezelpakketten vergelijken. Het is handig om je laatste facturen bij de hand te houden.
     </p>`,
    `<p>
        De prijzen en tarieven van de vergelijker worden dagelijks bijgewerkt. De beste alles-in-1-provider (Beste uit de Test) komt uit ons onderzoek 'de Providermonitor'.
        Deze beoordeling wordt 4 keer per jaar bijgewerkt.
     </p>`,
    `<p>Daar kunnen verschillende verklaringen voor zijn:</p>
     <ul>
        <li>De aanbieder levert niet op jouw adres (glasvezel ligt bijvoorbeeld nog niet overal).</li>
        <li>De internetsnelheid op je adres is te laag voor een bepaald pakket. Dan is 'internet, bellen en tv' niet mogelijk, maar misschien wel 'internet en bellen'.</li>
        <li>De aanbieder staat misschien onderaan de pagina bij 'meer resultaten'.</li>
        <li>De aanbieder zit niet in onze vergelijker.</li>
        <li>Toekomstige (glasvezel-)projecten staan niet in de vergelijker.</li>
     </ul>
     <br />
     <p>Let ook op toevoegingen bij huisnummers. Daar gaat wel eens wat mis. Gaat het nog steeds niet zoals het hoort, laat het ons dan weten.</p>`,
    `<p>De volgende internet- en tv-aanbieders zitten in onze vergelijker:</p>
     <p>Budget Alles-in-1, Caiway, Delta, Freedom Internet, KPN, Online.nl, Tele2, Telfort, Odido,XS4ALL, Youfone en Ziggo.</p>
     <p>
        Deze aanbieders vertegenwoordigen zo'n 90 tot 95% van de markt. Kleinere providers missen we helaas. 
        We streven ernaar om alle aanbieders in de vergelijker te hebben. Providers van internet en tv hoeven niet te betalen om in de vergelijker te mogen.
        Ze moeten wel 'toegang' verlenen tot systemen. Regelmatig voeren we hier gesprekken over met ontbrekende aanbieders.
     </p>`,
    '<p>Na ongeveer 2 weken krijg je het contract van de aanbieder. Daarna is de aansluiting binnen 4 tot 6 weken afgerond.</p>',
    `<p>
        Je hebt een bedenktijd van 14 werkdagen na ontvangst van de bevestiging van de aanbieder. Binnen deze periode kun je zonder opgaaf van reden je contract opzeggen.
        De wijze waarop je dit kunt doen, staat in het contract dat je ontvangt.
    </p>`,
    `<p>
        Gebruik je nu het e-mailadres van je provider (janjansen@provider.nl)? Dan heb je na een overstap nog een halfjaar recht op toegang tot je e-mailadres.
        Daarna raak je deze in principe kwijt.
     </p>
     <p>
        Bij XS4ALL, Solcon en KPN kun je je mailadres blijven gebruiken als je overstapt. Maar wel tegen een forse betaling (oplopend tot wel €15) per maand. Je neemt dan een
        extra e-mailpakket af. Wil je niet afhankelijk zijn van een provider? Gebruik dan een webmailadres zoals Gmail of Outlook.
     </p>`,
    `<p>Nee, dat doet de nieuwe provider normaal gesproken. Volg hiervoor de overstapaanwijzingen van de nieuwe provider.</p>
    <p>
      Let op! Er zijn uitzonderingen op de overstapservice. Zo wordt je tv-abonnement alleen opgezegd als die gekoppeld is aan een internetabonnement. 
      Neem bij twijfel contact op met de klantenservice.
    </p>`,
    `<p>Je ziet bij ons ook de resultaten van het panelonderzoek naar de kwaliteit van de grootste aanbieders. Zo kun je een goede afweging maken.</p>
    <br />
    <a href='https://www.consumentenbond.nl/internet/beste' target='_blank'><span>Bekijk de beste alles-in-1-provider.</span></a>`,
    `<p>Op deze pagina <a href='https://www.consumentenbond.nl/internet/service-cashback' target='_blank'>https://www.consumentenbond.nl/internet/service-cashback</a> staat hoe je de cashback kunt aanvragen.</p>`,
  ],
};

const howWeCompareContent = {
  labels: [
    'Hoe vergelijken we?',
    'Welke internetproviders vergelijken we?',
    'Onafhankelijk en actueel',
    'Wat vragen we van jou?',

    'Wat doen we voor jou?',
    'Ons verdienmodel',
    'Samenwerking Consumentenbond en RISK/Overstappen.nl',
    'Contactgegevens bij vragen',
  ],
  content: [
    `<p>
    Met onze internetvergelijker kun je de tarieven van kleine en grote providers vergelijken. De prijzen kunnen hierin verschillen. Hierbij houden we rekening met jouw persoonlijke situatie.
    </p>`,
    '<p>We tonen het aanbod van grote en kleine internetproviders: Budget Alles-in-1, Caiway, Delta, Freedom Internet, KPN, Online.nl, Odido, Youfone en Ziggo.</p>',
    `<p>
    Geen enkele internetprovider heeft een direct of indirect belang in onze vergelijker. Je vergelijkt dus volledig onafhankelijk. De prijzen en tarieven van de vergelijker zijn continue up-to-date.
    </p>`,
    `<p>
    Om goed te vergelijken vragen wij eerst je postcode en huisnummer. Tevens willen we weten wat je huidige aanbieder is of dat je gaat verhuizen. Met deze gegevens kunnen we het beste een passend aanbod vinden voor jouw adres.
    </p>`,
    `<p>In onze vergelijker kun je internetproviders onder andere vergelijken op:</p>
     <ul>
      <li>Prijs</li>
      <li>Snelheid</li>
      <li>Tv-aanbod</li>
     </ul>
     <p>
     Prijs is belangrijk, maar de kwaliteit van internet, tv en bellen natuurlijk ook. Bij het vergelijken zie je de resultaten van ons panelonderzoek naar de kwaliteit van de grootste internetproviders. Elk kwartaal publiceren we testoordelen die zijn gebaseerd op de ervaringen van zo'n 7500 consumenten. Zij beoordelen internetproviders op:
     </p>
     <ul>
      <li>Kwaliteit verbinding internet, tv en telefonie</li>
      <li>Kwaliteit klantenservice</li>
      <li>Algemene providerwaardering</li>
     </ul>`,
    `<p>
    We ontvangen een <a href='https://www.consumentenbond.nl/over-ons/wie-zijn-we/inkomsten' target='_blank'><span>vaste vergoeding</span></a> per overstapper. Dankzij dit geld kunnen we bijvoorbeeld de kwaliteit van internetproviders onderzoeken en de internetvergelijker onderhouden. Geen enkele aanbieder heeft een direct of indirect belang in deze vergelijker. Je vergelijkt dus volledig onafhankelijk.
    </p>`,
    `<p>
    De Consumentenbond biedt deze vergelijker aan in samenwerking met RISK Verzekeringen. RISK/Overstappen.nl is een leverancier van IT-platforms en distributeur van financiële producten. Zij hebben contact met de aanbieders en verzamelen de specificaties en actuele tarieven, en tonen deze in de vergelijker.
     </p>
     <p>
     Ook bij het aanvragen van een abonnement werken wij samen met RISK/Overstappen.nl. Hierbij moet je opnieuw een aantal gegevens invullen. RISK/Overstappen.nl handelt de aanvraag verder af met de aanbieder. 
    </p>`,
    `<p>
        Heb je vragen over deze vergelijker? Neem dan contact op met de Klantenservice van de Consumentenbond. Wij zijn bereikbaar op 088 – 90 01 771, ma - vr tussen 09.00 – 20.00 & za tussen 10.00 – 17.00. 
        Je kunt ons ook
        <a href='https://www.consumentenbond.nl/service/contactformulier' target='_blank'><span>een bericht sturen </span></a>
        via het contactformulier,
        <a href='https://www.facebook.com/consumentenbond/' target='_blank'><span>Facebook, </span></a>
        <a href='https://twitter.com/Consumentenbond' target='_blank'><span>Twitter </span></a>
        of onze
        <a href='https://community.consumentenbond.nl/consumentenbond-service-3' target='_blank'><span>Community.</span></a>
    </p>`,
  ],
};

const privacyStatementContent = {
  labels: [
    'Privacybeleid',
    'Inzage in je gegevens',
    'Identificatie bij een inzageverzoek',
    'Je gegevens wissen',
    'Rectificatie van je gegevens',
    'Privacyverklaring en cookiebeleid',
    'Contactgegevens',
  ],
  content: [
    '<p>Voor sommige diensten die wij aanbieden op onze website verwerken wij persoonsgegevens. Voor deze diensten werken wij soms samen met andere organisaties of bedrijven. Als consument heb je recht op privacy.</p>',
    "<p>Wil je weten welke gegevens we van jou hebben? Log dan in op <a href='https://www.consumentenbond.nl/login' target='_blank'><span>Mijn Consumentenbond</span></a>. Heb je geen account of wil je meer weten? Dien dan een inzageverzoek in via ons <a href='https://www.consumentenbond.nl/service/contactformulier'  target='_blank'><span>contactformulier</span></a> of bel met onze Klantenservice: 070 - 441 41 415.</p>",
    '<p>Om misbruik te voorkomen vragen wij je om je bij een inzageverzoek te identificeren. Bij een schriftelijk verzoek of een verzoek via e-mail kun je daarvoor een kopie van een geldig legitimatiebewijs meesturen. Vergeet niet om op de kopie jouw BSN (burgerservicenummer) &eacute;n jouw pasfoto af te schermen. Je kunt hier bijvoorbeeld de KopieID-app voor gebruiken. Ook wanneer je je aanvraag telefonisch indient, zullen we je aan de hand van de bij ons bekende gegevens moeten kunnen identificeren voordat wij jouw verzoek in behandeling nemen.</p>',
    "<p>Wil je niet langer dat wij jouw gegevens opslaan? Dien dan een verzoek in om je persoonsgegevens te laten verwijderen. Dat kan via ons <a href='https://www.consumentenbond.nl/service/contactformulier' target='_blank'><span>contactformulier</span></a> of bel met onze Klantenservice: 070 - 441 41 415. Wij zorgen er dan voor dat je gegevens binnen 4 weken zijn verwijderd.</p>",
    '<p>Neem contact met ons op als we je gegevens foutief hebben opgeslagen. Wij zullen dit dan zo snel mogelijk (laten) corrigeren.</p>',
    '<p>In onze privacyverklaring leggen wij uit hoe wij je persoonsgegevens verzamelen, hoe wij omgaan met deze gegevens en waarvoor wij je persoonsgegevens gebruiken. We vinden het belangrijk dat jij hier goed van op de hoogte bent en raden je aan deze verklaring zorgvuldig te lezen.</p><p>In ons cookiebeleid leggen wij uit hoe cookies werken, welke type cookies we plaatsen en hoe je ze kunt blokkeren en verwijderen.</p>',
    "<p>Heb je vragen over je rechten op het gebied van privacy? Neem dan <a href='https://www.consumentenbond.nl/service/contactformulier' target='_blank'><span>contact</span></a> met ons op.</p>",
  ],
};

const basicMembershipBenefitsContent = {
  labels: [
    'De voordelen van het Basislidmaatschap',
    'Overstap- en bespaarservice',
    'Collectief voordeel',
    'Voordeelcoach-app',
    'We komen in actie voor jou',
  ],
  content: [
    '<p>Stap je over? Dan heten we je welkom met ons Basislidmaatschap en profiteer je direct van veel voordeel. <em>De </em><strong><em>eerste 3 maanden zijn gratis</em></strong><em>. Daarna betaal je &euro;3,25 per maand. Je kunt je lidmaatschap elke maand opzeggen</em>.</p>',
    '<p>We helpen je om aanbieders met elkaar te vergelijken op prijs en voorwaarden. Zo weet je direct of het slim is om nog een jaar bij je energieleverancier te blijven. En of je beter af bent bij een andere zorgverzekeraar. Weinig moeite, maar veel voordeel in je portemonnee. We hebben meer dan 10 overstap- en bespaardiensten voor je. Of het nou gaat om je autoverzekering, internetabonnement of woonverzekering.</p>',
    '<p>Ook kun je meedoen aan onze collectieven voor private lease, energie en cv-ketels. Je ontvangt van ons de beste deals met betrouwbare voorwaarden en een eerlijk maandbedrag. En je hoeft je niet meer te verdiepen in de kleine lettertjes.</p>',
    '<p>Deze app zoekt altijd naar de beste aanbiedingen voor verzekeringen en energie. Dus geen gedoe met uitzoeken en prijzen vergelijken. Dit doet de app automatisch voor je. Zo hoef jij alleen nog maar te kiezen.</p>',
    '<p>Met steun van leden zetten we ons dagelijks in voor de verbetering en bescherming van jouw rechten. Dat doen we op allerlei terreinen. Van financi&euml;n tot zorg, van elektronica tot privacy en van reizen tot voeding. En als jouw rechten worden bedreigd komen we samen in actie.</p>',
  ],
};

const nlzietContent = {
  labels: [
    'Uitleg over de actie',
    'Actieperiode',
    'Deelname en overige voorwaarden',
    'Wat is NLZIET?',
    'Waar is NLZIET beschikbaar?',
    'Hoe maak ik een account aan?',
    'Kan ik op twee apparaten tegelijkertijd tv-kijken?',
    'Hoe werkt de gratis proefperiode bij NLZIET?',
    'Wat houdt de NLZIET actie in?',
  ],
  content: [
    '<p>Bij overstap via de internet en tv vergelijker van de Consumentenbond krijg je 2 maanden gratis een NLZIET abonnement. Na deze 2 maanden wordt het abonnement automatisch omgezet naar een abonnement voor onbepaalde tijd tegen de reguliere abonnementsprijs van €7.95 per maand, welke maandelijks opzegbaar is. Heb je al een abonnement bij NLZIET dan krijg je 1 maand gratis. Deze gaat direct in of aansluitend op een eventueel lopend standaard maandabonnement.</p>',
    `<ul>
      <li>De actieperiode loopt van 20 juni 2022 tot en met 15 juli 2022</li>
      <li>De actiecode kan uiterlijk tot en met 31 juli 2022 ingewisseld worden</li>
    </ul>`,
    `<ul>
      <li>Na overstap ontvang je een mail met daarin de actiecode en hoe je deze kunt verzilveren.</li>
      <li>Om deel te nemen aan de actie is een registratie nodig. Voor nieuwe registraties geldt dat voor de eerste (proef)maand €0,01 in rekening wordt gebracht in verband met verificatiedoeleinden van de betaalwijze.</li>
      <li>Er kan slechts 1 actiecode worden verzilverd per persoon. De actiecode is niet overdraagbaar en niet inwisselbaar voor geld.</li>
      <li>De actie is alleen geldig voor inwoners van Nederland.</li>
      <li>Deze actie is niet te combineren met andere acties van NLZIET.</li>
      <li>Op het gebruik van dit actieabonnement zijn de algemene voorwaarden van NLZIET van toepassing alsmede het privacy & cookiestatement van NLZIET. Door deelname aan de actie accepteert de deelnemer deze voorwaarden.</li>
      <li>NLZIET is niet aansprakelijk voor eventuele druk- of zetfouten.</li>
      <li>NLZIET kan eventuele frauduleus overkomende aanmeldingen weigeren.</li>
      <li>Voor vragen over deze actievoorwaarden kun je terecht bij NLZIET, ’s-Gravelandseweg 80, 1217EW Hilversum, info@nlziet.nl.</li>
    </ul>`,
    '<p>Met NLZIET kun je online tv-kijken wanneer jij wilt zonder kabels of kastjes. Met een abonnement kijk je voordelig naar 37 zenders van de Nederlandse en Vlaamse televisie. Je kunt de app van NLZIET installeren op verschillende apparaten, zoals je tv, laptop, tablet of telefoon. Daarna kun je direct beginnen met tv-kijken.</p>',
    '<p>NLZIET is in de hele EU te gebruiken.</p>',
    '<p>Eerst maak je een account aan op www.nlziet.nl. Je kunt NLZIET één maand gratis uitproberen. We vragen je om een betaling van 1 eurocent ter controle van je bankgegevens. Na de eerste maand betaal je 7,95 per maand en kun je onbeperkt kijken. Je kunt betalen met PayPal, iDeal of met je creditcard. Je zit nergens aan vast!</p>',
    '<p>Ja, dat kan. Je hebt hier geen tweede tv-aansluiting voor nodig, alleen een goed werkende internetverbinding.</p>',
    '<p>Tijdens de proefperiode geniet je één maand gratis van NLZIET. Ervaar zelf het gemak van NLZIET en kijk live, terug en vooruit naar de 37 zenders van NPO, RTL, SBS en VRT. Je proefabonnement start met een betaling van 1 eurocent. Als je tevreden bent en gebruik wil blijven maken van NLZIET, hoef je niets te doen. Na je kennismakingsperiode wordt je abonnement vanzelf omgezet naar een maandabonnement. Je zit nergens aan vast, je abonnement is op elk moment opzegbaar.</p>',
    '<p>Bij overstap naar een internetabonnement via de internet en tv vergelijker van de Consumentenbond krijg je 2 maanden gratis een NLZIET abonnement. Na deze 2 maanden wordt het abonnement automatisch omgezet naar een abonnement voor onbepaalde tijd tegen de reguliere abonnementsprijs van €7.95 per maand, welke maandelijks opzegbaar is.</p><p>Heb je al een abonnement bij NLZIET dan krijg je 1 maand gratis. Deze gaat direct in of aansluitend op een eventueel lopend standaard maandabonnement.</p>',
  ],
};

export {
  basicMembershipBenefitsContent,
  faqContent,
  howWeCompareContent,
  privacyStatementContent,
};

// This needs to be changed. The config must be serializable (ie. no function call)
export const faqItems = contentToAccordionItems(faqContent);
export const howWeCompareItems = contentToAccordionItems(howWeCompareContent);
export const basicMembershipBenefitsItems = contentToAccordionItems(
  basicMembershipBenefitsContent,
);
export const privacyStatementItems = contentToAccordionItems(
  privacyStatementContent,
);
export const nlzietItems = contentToAccordionItems(nlzietContent);
